import React from 'react';

export default () => {
    return (
        <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="2.5" width="3" height="12" rx="1" fill="#00787A"/>
            <rect x="8.5" width="3" height="12" rx="1" fill="#00787A"/>
        </svg>
    );
};
